
import groupBy from "lodash/groupBy"

export default {
  props: {
    info: {
      type: Object,
      default: () => ({
        splitOrder: false,
        orderList: [],
        tokenInfos: []
      })
    }
  },
  data() {
    return {
      visible: false,
      stamps: [],
      currentStamp: {}
    }
  },
  watch: {
    info: {
      handler(nVal) {
        const { tokenInfos } = nVal
        if (tokenInfos?.length > 0) {
          const result = groupBy(tokenInfos, "tokenType")
          if (result[1]) {
            this.stamps.push({
              list: result[1],
              name: this.$t("orderDetails.saverStamps")
            })
          }
          if (result[2]) {
            this.stamps.push({
              list: result[2],
              name: this.$t("orderDetails.funStamps")
            })
          }
        }
      },
      immediate: true
    }
  },
  methods: {
    handleView(currentStamp) {
      this.visible = true
      this.currentStamp = currentStamp
    }
  }
}
